import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const BlogEditPage = lazy(() => import("../../components/blogs/BlogEditPage"));

const blogRoutes: RouteObject[] = [
  {
    path: "/blogs/:id/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <BlogEditPage />
      </Suspense>
    ),
  },
];

export default blogRoutes;
